import { themeV2 } from '@features/lci-report/domain/theme-v2';
import { DEFAULT_FONT } from '@features/lci-report/utils/constants-v2';
import { contentSlideHeaderV2 } from '@features/lci-report/utils/slide-header-v2';
import type { Slide } from '@features/powerpoint';
import { composeSlides, parseTags } from '@features/powerpoint';
import { MASTER_NAMES } from '@features/lci-report/utils/shared-presentation-config-v2';
import {
  minimumsTableV2,
  type MinimumsTableV2Data,
} from './components/minimums-table-v2';

const TABLE_X = 2.33;
const TABLE_Y = 1.54;
const FOOTNOTE_Y = 6.48;

const combinedData: MinimumsTableV2Data = {
  headers: ['LCI Report Medium', 'Minimum Data Threshold*'],
  body: [
    ['Digital LCI \u2013 Connected TV/OTT Inventory', '15M Impressions'],
    ['Digital LCI - Display, Streaming Audio', '10M Impressions'],
    ['Digital LCI - by Dimension', '+5M Impressions per Dimension (total 15M)'],
    ['Digital OOH', '15M Impressions & 20+ Locations'],
    ['OOH LCI', '~1M Users'],
    ['TV LCI \u2013 Linear TV', '10-25M HHs, depending on TV partner'],
    ['TV LCI \u2013 Addressable TV', '1M HHs per operator'],
    ['Website LCI', '25M Page Views / LCI Pixel Fires'],
    ['YouTube', '50M Impressions'],
    ['LCI for CPG', '15M Impressions (Depending on brand)'],
    ['LCI for Auto', '25M Impressions'],
  ],
};

const baseSlide = (): Slide => ({
  slideMaster: MASTER_NAMES.titleAndContent,
  texts: [
    contentSlideHeaderV2(
      parseTags(
        'Lift, Conversion, & Incrementality<sup>®</sup> Guideline Minimums'
      ),
      {
        color: themeV2.colors.metricBlue,
        h: 1.29,
        w: 9.5,
      }
    ),
  ],
});

const footnote = (): Slide => ({
  texts: [
    {
      text: [
        {
          text: 'Feasibility assessment required by InMarket Measurement Team to request waiver of required minimum campaign impressions.',
          options: {
            italic: true,
            breakLine: true,
          },
        },
        {
          text: 'Minimum Campaign Flight (Non-CPG) = 2 weeks; CPG = 4 weeks',
          options: {
            italic: true,
            breakLine: true,
          },
        },
        {
          text: 'Minimum Locations Needed for Measurement = 20 Locations',
          options: {
            italic: true,
            breakLine: true,
          },
        },
        {
          text: 'HH = House Holds / M = Millions',
          options: {
            italic: true,
          },
        },
      ],
      options: {
        fontSize: 10,
        fontFace: DEFAULT_FONT,
        color: themeV2.colors.metricBlue,
        x: 2.21,
        y: FOOTNOTE_Y,
        w: 10.38,
        h: 0.77,
        lineSpacingMultiple: 1.15,
      },
    },
  ],
});

export const lciGuidelineMinimumsSlideV2 = (): Slide =>
  composeSlides(
    baseSlide(),
    minimumsTableV2({
      data: combinedData,
      options: {
        rowH: 0.38,
        x: TABLE_X,
        y: TABLE_Y,
        w: 8.67,
      },
    }),
    footnote()
  );
